module.exports = [{
      plugin: require('A:/dev/dm-stuff.ru/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
